import React from "react";

import { maybe } from "@utils/misc";

import { PlaceholderImage } from "@components/atoms";
import { CachedImage } from "../";
import { IProps } from "./types";

export const Thumbnail: React.FC<IProps> = ({
  source,
  children,
  ...props
}: IProps) => {
  const { thumbnail, thumbnail2x } = source;
  const originalImage =
    source.images && source.images.find(image => image && image.url);
  const thumbnailUrl =
    (thumbnail && thumbnail.url) || (thumbnail2x && thumbnail2x.url);
  const originalUrl = (originalImage && originalImage.url) || undefined;
  const imageAlt =
    (thumbnail && thumbnail.alt) || (originalImage && originalImage.alt) || "";

  if (!thumbnailUrl && !originalUrl) {
    return <PlaceholderImage />;
  }

  return (
    <CachedImage
      {...props}
      url={thumbnailUrl || originalUrl}
      url2x={thumbnail ? maybe(() => thumbnail2x!.url) : undefined}
      defaultImage={originalUrl}
      alt={imageAlt}
    >
      {children}
    </CachedImage>
  );
};
